<template>
  <v-dialog width="1000" v-model="dialog" persistent>
    <template v-slot:activator="{ on }" v-if="!noButton">
      <v-btn fab fixed bottom right color="green" v-on="on" class="ma-12">
        <v-icon color="white">mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-dialog v-model="alertError" v-if="alertError" width="600">
      <v-card>
        <v-card-title class="error--text">Errore</v-card-title>
        <v-card-text>
          <v-icon class="mr-4">mdi-alert</v-icon>
          {{ errorMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="alertError = false">Chiudi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alertOk" width="600">
      <v-card color="success" dark class="pa-4">
        <v-icon class="mr-4">mdi-check</v-icon>
        Contabile inserita con successo
      </v-card>
    </v-dialog>

    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        Nuova Contabile
      </v-card-title>
      <v-card-text>
        <v-row class="mt-4">
          <v-col cols="8">
            <v-form v-model="valid" ref="form">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-autocomplete
                    :readonly="cliente_prop != null"
                    v-model="cliente"
                    :items="items"
                    label="Seleziona cliente"
                    item-text="nome"
                    item-value="iva"
                    outlined
                    prepend-inner-icon="mdi-account"
                    :rules="[(v) => !!v || 'Seleziona un cliente']"
                    hide-details
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-divider class="my-4"></v-divider>
              <v-row>
                <v-col cols="6">
                  <v-menu
                    ref="menu"
                    v-model="menu_data"
                    :close-on-content-click="false"
                    :return-value.sync="data"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataFormatted"
                        label="Data"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="data" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu_data = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(data)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-select
                    :items="items_tipo"
                    v-model="tipo"
                    :disabled="ordine_id_prop == ''"
                    item-text="tipo"
                    item-value="id"
                    label="Tipo"
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12">
                  <v-alert
                    v-if="ordine_id_prop && tipo_consegna == 1"
                    :color="trasp_gratuito ? 'info' : 'red '"
                    :icon="trasp_gratuito ? 'mdi-truck' : 'mdi-cash'"
                    dense
                    text
                    outlined
                  >
                    <v-row align="center">
                      <v-col cols="10">
                        {{
                          trasp_gratuito
                            ? "Trasporto gratuito"
                            : " Spese di trasporto € " +
                              importo_trasporto.toFixed(2)
                        }}
                      </v-col>
                      <v-col cols="2">
                        <v-btn
                          v-if="!trasp_gratuito"
                          text
                          small
                          color="red"
                          @click="rimuovi_trasporto()"
                          >Rimuovi</v-btn
                        >
                        <v-btn
                          v-else
                          text
                          small
                          color="green"
                          @click="aggiungi_trasporto()"
                          >Aggiungi</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>
                <v-col cols="6" class="mt-n4">
                  <v-text-field
                    v-if="tipo == 1"
                    :disabled="!cliente"
                    prepend-inner-icon="mdi-cash"
                    prefix="€"
                    :suffix="
                      !this.hide_iva
                        ? '(' +
                          (
                            this.importo_imponibile + this.importo_trasporto
                          ).toFixed(2) +
                          ' + Iva)'
                        : ''
                    "
                    v-model="importo_totale"
                    label="Importo"
                    outlined
                    @focus="$event.target.select()"
                    :rules="[
                      (v) => !!v || 'Inserisci un importo',
                      (v) => !isNaN(v) || 'Deve essere un numero',
                    ]"
                  />
                  <v-text-field
                    v-else-if="tipo == 2"
                    :disabled="!cliente"
                    prepend-inner-icon="mdi-cash"
                    prefix="€ -"
                    v-model="importo_totale"
                    label="Importo Credito"
                    outlined
                    @focus="$event.target.select()"
                    :rules="[
                      (v) => !!v || 'Inserisci un importo',
                      (v) => !isNaN(v) || 'Deve essere un numero',
                    ]"
                  />
                  <v-text-field
                    v-else-if="tipo == 3"
                    prepend-inner-icon="mdi-cash"
                    prefix="€"
                    v-model="importo_totale"
                    label="Importo Iva Fattura"
                    outlined
                    @focus="$event.target.select()"
                    :rules="[
                      (v) => !!v || 'Inserisci un importo',
                      (v) => !isNaN(v) || 'Deve essere un numero',
                    ]"
                  />
                </v-col>
                <v-col cols="6" class="mt-n4">
                  <v-switch
                    v-if="tipo == 1 || tipo == 2"
                    v-model="verde"
                    label="Verde"
                    inset
                    color="green"
                    hide-details
                  ></v-switch>
                  <v-text-field
                    v-if="tipo == 3"
                    readonly
                    prefix="€"
                    prepend-inner-icon="mdi-cash"
                    @focus="$event.target.select()"
                    v-model="importo_imponibile_fattura"
                    label="Imponibile Fattura"
                    outlined
                  />
                </v-col>
              </v-row>
              <v-divider class="my-4"></v-divider>
              <v-row>
                <v-col cols="6">
                  <v-select
                    :disabled="!cliente || tipo != 1"
                    :items="[
                      { '_id.$oid': '', numero: 'Nessun Ordine' },
                      ...ordini,
                    ]"
                    item-text="numero"
                    item-value="_id.$oid"
                    prepend-inner-icon="mdi-clipboard-text"
                    v-model="ordine_id"
                    label="# Ordine"
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-if="tipo == 1 && subconteggi.length > 0"
                    :items="subconteggi"
                    v-model="id_sub_conteggio"
                    item-text="subNumero"
                    item-value="id.$oid"
                    label="Sub"
                    outlined
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    :disabled="verde || tipo == 2"
                    prepend-inner-icon="mdi-file-document"
                    @focus="$event.target.select()"
                    v-model="computedDdt"
                    label="Documento di Trasporto"
                    outlined
                    :rules="[
                      (v) =>
                        verde || !!v || 'Inserisci un documento di trasporto',
                    ]"
                  />
                </v-col>
                <v-col cols="4">
                  <v-select
                    :disabled="verde || tipo == 2"
                    :items="anni_rif"
                    v-model="anno_rif"
                    label="Anno Rif."
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-divider class="mb-4"></v-divider>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="note"
                    label="Note"
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-checkbox
                    hide-details
                    :disabled="tipo != 1"
                    label="Segna come pagato"
                    v-model="saldato"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col
            cols="4"
            class="pl-8"
            style="max-height: 600px; overflow-y: auto"
          >
            <v-row no-gutters class="mb-4">
              <span class="text-subtitle-1">Situazione Sospesi</span>
            </v-row>
            <v-row no-gutters v-if="contabili_non_saldate.length > 0">
              <v-col
                cols="12"
                v-for="month in groupedByMonth"
                :key="month.mese"
              >
                <v-col cols="12" class="font-weight-light">
                  <span
                    ><u>{{ month.mese }}</u></span
                  >
                </v-col>
                <v-col cols="12">
                  <v-row
                    v-for="contabile in month.contabili"
                    :key="contabile.id"
                    no-gutters
                  >
                    <v-col cols="5">
                      <span>{{ format_ts_to_date(contabile.ts) }}</span>
                    </v-col>
                    <v-col cols="3">
                      <span>{{ contabile.ddt }}</span>
                    </v-col>
                    <v-col cols="4">
                      <span
                        :class="
                          contabile.tipo == 1
                            ? contabile.verde
                              ? 'green--text'
                              : 'blue--text'
                            : contabile.tipo == 2
                            ? 'green white--text pa-1'
                            : 'purple--text'
                        "
                        >€ {{ contabile.importo.toFixed(2) }}</span
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12">
                <span>Nessun sospeso per questo cliente</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          outlined
          :loading="loadingSalva"
          :disabled="!valid"
          @click="salvaContabile"
          >Salva</v-btn
        >
        <v-btn color="grey" text @click="dialog = false">Annulla</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import nuova_contabile_mixin from "../mixin/nuova_contabile_mixin";
export default {
  mixins: [nuova_contabile_mixin],
};
</script>

